import { render, staticRenderFns } from "./FloatingLogo.vue?vue&type=template&id=40505670&"
import script from "./FloatingLogo.vue?vue&type=script&lang=ts&"
export * from "./FloatingLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports